
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";

import PageHeading from "@/components/PageHeading.vue";
import { ViewAnalytics } from "@/mixins";
import { MetadataKeys } from "@/types";

@Component({
  components: {
    PageHeading,
    SearchBar: () => import(/* webpackChunkName: "async-modules" */ "@/components/SearchBar.vue"),
    SearchResults: () => import(/* webpackChunkName: "async-modules" */ "@/components/SearchResults.vue"),
    BriefcaseFolderMoveDialog: () =>
      import(/* webpackChunkName: "async-modules" */ "@/components/BriefcaseFolderMoveDialog.vue"),
  },
})
export default class Search extends mixins(ViewAnalytics) {
  // Override for PageTitle mixin
  pageName = "Search";

  mounted(): void {
    this.setAnalyticsMetadata(MetadataKeys.PAGE_TYPE, "Search or Content List");
    this.setAnalyticsMetadata(MetadataKeys.SITESECTION, "Search or Content List");
    this.pushPageViewEvent();
  }
}
